import $api from "@/zapi-frontend/shared/api/axios";

export async function postCancelGeneration(generationId: number) {
  await $api.post("/chat/cancel", { generationId });
}
